import { makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

export const useStyles = makeStyles({
    cellHeader: {
        position: 'relative',
        transition: `opacity ${tokens.durationFast} ease-in-out`,
    },
    cellHeaderHovered: {
        opacity: 0.5,
    },
    cellLayout: {
        height: '100%',
        overflow: 'hidden',
    },
    resizeHandlerContainer: {
        position: 'absolute',
        width: px(17),
        height: '100%',
        top: '50%',
        right: px(-16),
        transform: 'translateY(-50%)',
        backgroundColor: tokens.colorTransparentBackground,
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none',
        zIndex: 1,
    },
    resizeHandlerContainerDisabled: {
        cursor: 'not-allowed !important',
        opacity: 0.25,
    },
    resizeHandlerContainerLastColumn: {
        width: px(9),
        right: px(-8),
    },
    resizeHandler: {
        position: 'absolute',
        width: px(1),
        height: '100%',
        top: '50%',
        right: px(8),
        borderRadius: px(0),
        transform: `translateY(-50%)`,
        backgroundColor: tokens.colorNeutralStroke2,
        transition: ['width', 'height', 'right', 'border-radius']
            .map((transition) => `${transition} 0.2s ease-in-out`)
            .join(', '),
    },
    resizeHandlerDisabled: {
        cursor: 'not-allowed !important',
        opacity: 0.25,
    },
    resizeHandlerDragging: {
        width: px(5),
        height: `calc(100% - ${px(8)})`,
        right: px(6),
        borderRadius: px(2),
    },
    resizeHandlerDraggingLastColumn: {
        right: px(0),
    },
    resizeHandlerDraggingLastColumnDragging: {
        right: px(-2),
    },
});
